import { useContext } from "react";

import { PaginationType } from "@_types/shared";
import { CompanyContext } from "@contexts/company/CompanyContext";
import { getCompanies, updateDefaultCompany } from "@services/http/settings";
import { useMutation, useQuery } from "@tanstack/react-query";

export function useGetCompanies({ pageSize = 99, page = 1, ...params }: PaginationType) {
  const { setCurrentCompany } = useContext(CompanyContext);

  const query = useQuery(
    ["/companies", "/settings", pageSize, page],
    () => getCompanies({ page, pageSize, ...params }),
    {
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
      onSuccess: ({ data }) => {
        setCurrentCompany(data.data.find(company => company.isDefault));
      },
    }
  );

  return {
    ...query,
    companies: query.data?.data.data,
  };
}

export function useChangeCompany() {
  return useMutation((uuid: string) => {
    return updateDefaultCompany(uuid);
  });
}
